import axios, { AxiosRequestConfig } from 'axios'
import { isClient } from './index'
// 在nodejs中使用
const https = isClient() ? '' : require('https')
import { IServiceObject } from '../types'
import { logger } from '../logger'

const opt: AxiosRequestConfig = {
  timeout: 20000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  withCredentials: true,
}
// 服务端请求时，绕过证书验证
if (!isClient()) {
  opt.httpsAgent = new https.Agent({
    rejectUnauthorized: false,
  })
}
const instance = axios.create(opt)
export type requestOpt = {
  /**
   * 接口请求地址
   * 开发环境时，页面访问不是/api开头的接口，需要在next-congfig的rewrites指定转发，避免跨域
   */
  url: string
  /**
   * 一般不需要设置，内部自动添加
   * 在isInternalReq为true时，此设置无效
   */
  baseURL?: string
  /**
   * url地址中的参数对象
   */
  params?: { [key: string]: any }
  /**
   * 请求体中的数据对象
   */
  data?: { [key: string]: any }
  /**
   * 是否需要使用凭证
   */
  withCredentials?: boolean
  /**
   * 请求header信息
   */
  headers?: any
  /**
   * 是否是内部使用接口，标识内部使用时，baseUrl是内部地址
   */
  isInternalReq?: boolean
}
/**
 * get方式请求数据
 * @param opt 传递所需参数
 */
export const get = async <T>(opt: requestOpt) => {
  try {
    if (opt.isInternalReq) {
      const internalReqHeader = { 'x-gate-internal': 1 }
      const internalReqHost = { 'x-http-hostname': 'www.gate.io' }
      opt.headers = Object.assign({}, opt.headers, internalReqHeader, internalReqHost)
      opt.baseURL = process.env.SERVER_URL
    }
    const ret = await instance.get<IServiceObject<T>>(opt.url, opt)
    return ret.data
  } catch (e) {
    logger.error(`接口请求报错：${opt.url}`, opt.headers)
    throw Error('请求数据报错，请稍后') // 服务端请求报错，会在接口层面进行Catch处理
  }
}
/**
 * post请求，暂时只支持在客户端调用
 * @param opt 请求参数，使用表单格式传递
 */
export const post = async <T>(opt: Pick<requestOpt, 'url' | 'data'>) => {
  try {
    const params = new URLSearchParams()
    for (const k in opt.data) {
      params.append(k, opt.data[k])
    }
    const ret = await instance.post<IServiceObject<T>>(opt.url, params)
    return ret.data
  } catch (e) {
    console.error((e as Error).message, opt.url)
  }
}
/**
 * axios实例，自定义访问使用
 */
export default instance
